var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.6797 6.5625H41.7344V63.0273H55.6797V6.5625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5898 66.6172H53.409H55.6797V63.5876V7.02949V4H53.409H38.5898V10.059H51.1383V60.5582H38.5898V66.6172Z",
    fill: "#CED8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.195 45.9729C66.5624 44.6115 67.6532 43.0486 68.4423 41.319C69.3559 39.3172 69.8193 37.1911 69.8193 35C69.8193 32.8089 69.3559 30.6831 68.4423 28.681C67.6532 26.9514 66.5624 25.3885 65.195 24.0271C64.9312 23.7644 64.9366 23.3491 65.2023 23.088L67.1139 21.2072C67.3968 20.9291 67.8647 20.9318 68.147 21.2103C69.8892 22.9278 71.277 24.9053 72.2776 27.0982C73.4204 29.6026 74 32.2611 74 35C74 37.7389 73.4204 40.3974 72.2776 42.9018C71.277 45.0947 69.8892 47.0722 68.147 48.7897C67.8647 49.0682 67.3965 49.0709 67.1139 48.7928L65.202 46.912C64.9366 46.6509 64.9312 46.2356 65.195 45.9729Z",
    fill: "#FF8087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1163 35C62.1163 33.1029 61.4275 31.3175 60.1644 29.9106C59.9351 29.6555 59.9482 29.2671 60.1878 29.0217L61.9664 27.2011C62.2316 26.9296 62.6745 26.9331 62.9329 27.211C64.9159 29.343 66 32.083 66 35C66 37.9171 64.9159 40.6571 62.9329 42.789C62.6745 43.0669 62.2316 43.0704 61.9664 42.7987L60.1878 40.9784C59.9482 40.733 59.9351 40.3445 60.1644 40.0892C61.4275 38.6825 62.1163 36.8971 62.1163 35Z",
    fill: "#FF8087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2891 70L21.9102 65.0001V6.66668L45.2891 0V70Z",
    fill: "#E6E9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.805 45.9729C11.4376 44.6115 10.3468 43.0486 9.55766 41.319C8.64414 39.3172 8.18068 37.1911 8.18068 35C8.18068 32.8089 8.64414 30.6828 9.55766 28.681C10.3468 26.9514 11.4376 25.3885 12.805 24.0271C13.0688 23.7644 13.0631 23.3491 12.7977 23.088L10.8861 21.2072C10.6032 20.9291 10.1353 20.9318 9.85302 21.2103C8.11083 22.9278 6.72301 24.9053 5.72241 27.0982C4.57956 29.6026 4 32.2611 4 35C4 37.7389 4.57956 40.3974 5.72241 42.9018C6.72301 45.0947 8.11083 47.0722 9.85302 48.7897C10.1353 49.0682 10.6035 49.0709 10.8861 48.7928L12.798 46.912C13.0634 46.6509 13.0688 46.2356 12.805 45.9729Z",
    fill: "#FF8087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8837 35C15.8837 33.1029 16.5725 31.3175 17.8356 29.9106C18.0649 29.6555 18.0518 29.2671 17.8122 29.0217L16.0336 27.2011C15.7684 26.9296 15.3255 26.9331 15.0671 27.211C13.0841 29.343 12 32.083 12 35C12 37.9171 13.0841 40.6571 15.0671 42.789C15.3255 43.0669 15.7684 43.0704 16.0336 42.7987L17.8122 40.9784C18.0518 40.733 18.0649 40.3445 17.8356 40.0892C16.5725 38.6825 15.8837 36.8971 15.8837 35Z",
    fill: "#FF8087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.375 38.0176C43.375 39.0053 42.475 39.7484 41.5051 39.5614C40.7652 39.4188 40.2305 38.7712 40.2305 38.0176V37.7247C40.2305 36.9711 40.7651 36.3235 41.5051 36.1809C42.4749 35.9939 43.375 36.737 43.375 37.7247V38.0176Z",
    fill: "#BDBDBD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 78,
    height: 78,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoor);
export default __webpack_public_path__ + "static/media/door.c57e5f0f30520fc02c58f38d51ac7ab3.svg";
export { ForwardRef as ReactComponent };